import styled from 'styled-components'

export const Container = styled.div`
  max-width: 80vw;
  font-size: 2.5rem;
`

export const Address = styled.div`
  text-align: center;
`

export const Img = styled.img`
  max-width: 100%;
  max-height: 40vh;
`

export const TwoByTwo = styled.div`
  display: grid;
  gap: 1rem;
  @media only screen and (min-width: 800px) {
    grid-auto-flow: column;
    grid-auto-columns: 1fr;
  }
`